const normalizeName = (value: string | null | undefined) =>
  value?.replace(/\s+/g, ' ').trim() ?? '';

/**
 * Reads composer metadata from an uncompressed MusicXML document.
 *
 * MusicXML normally stores this in identification/creator with
 * type="composer". Some exporters omit the type, so an untyped creator is
 * used only when no explicitly typed composer is present.
 */
export const extractComposerFromMusicXml = (musicXml: string): string => {
  const document = new DOMParser().parseFromString(musicXml, 'application/xml');
  if (document.querySelector('parsererror')) return '';

  const creators = Array.from(document.querySelectorAll('identification > creator'));
  const explicitlyTypedComposers = creators.filter(
    (creator) => creator.getAttribute('type')?.toLowerCase() === 'composer',
  );
  const candidates =
    explicitlyTypedComposers.length > 0
      ? explicitlyTypedComposers
      : creators.filter((creator) => !creator.getAttribute('type'));

  return Array.from(
    new Set(candidates.map((creator) => normalizeName(creator.textContent)).filter(Boolean)),
  ).join(', ');
};
